<template lang="pug">
  bloco#diretorias
    //- HEADER
    header(slot="header")
      titulo.-withbar.-upper Diretorias
    //- CONTENT
    .conteudo(slot="content")
      carousel.diretorias(
      :paginationEnabled="false",
      :navigationEnabled="true",
      :navigationClickTargetSize="0",
      :navigationNextLabel="proximo",
      :navigationPrevLabel="anterior",
      :perPage="1",
      :perPageCustom="breakpoints")
        slide
          //- router-link(:to="{ name: 'DCFIndex' }").item
          .item
            bloquinho.--green-hover
              i(slot="icone").proad.proad-cifrao
              template(slot="sigla") DCF
              p(slot="texto") A Diretoria de Contabilidade e Finanças é o órgão central do sistema de administração financeira e contábil da universidade.
        slide
          //- router-link(:to="{ name: 'DGCIndex' }").item
          .item
            bloquinho.--wine-hover
              i(slot="icone").proad.proad-livro
              template(slot="sigla") DC
              p(slot="texto") A Diretoria de Contratos coordena, planeja e acompanha a execução fisico-financeira fiscalizando administrativamente todos os contratos.
        slide
          //- router-link(:to="{ name: 'DGIIndex' }").item
          .item
            bloquinho.--yellow-hover
              i(slot="icone").proad.proad-chat
              template(slot="sigla") DL
              p(slot="texto") A Diretoria de Logística tem a finalidade de planejar, coordenar e organizar o sistema de arquivos da UFRN em sua forma documental e eletrônica.
        slide
          router-link(:to="{ name: 'DCOMIndex' }").item
            bloquinho.--blue-hover
              i(slot="icone").proad.proad-predio
              template(slot="sigla") DCOM
              p(slot="texto") A Diretoria de Compras tem a finalidade de planejar, coordenar, controlar e executar as compras institucionais de âmbito nacional e internacional.
        slide
          //- router-link(:to="{ name: 'DSPIndex' }").item
          .item
            bloquinho.--orange-hover
              i(slot="icone").proad.proad-escudo
              template(slot="sigla") DSP
              p(slot="texto") A Diretoria de Segurança Patrimonial tem a finalidade de planejar, coordenar, executar e avaliar a segurança patrimonial.
</template>

<style lang="scss">
  // Style
  #diretorias {
    .item {
      display: block;
      margin: 0 auto;
      max-width: 137px;
      &:hover { text-decoration: none }
      .proad { font-size: 4rem; line-height: 50px; }
    }

    > .conteudo {
      margin: 0 20px;
    }

    .carousel-arrows {
      color: $color-grey-normal;
    }
  }
</style>

<script>
import Bloco from 'COMPONENTS/Bloco'
import Bloquinho from 'COMPONENTS/Bloquinho'
import Titulo from 'COMPONENTS/ElementTitle'
import { Carousel, Slide } from 'vue-carousel'
export default {
  props: ['breakpoints'],
  components: {
    Bloco,
    Bloquinho,
    Carousel,
    Titulo,
    Slide
  },
  data () {
    return {
      proximo: '<i class="fa fa-angle-right fa-4x carousel-arrows">',
      anterior: '<i class="fa fa-angle-left fa-4x carousel-arrows">'
    }
  }
}
</script>



// WEBPACK FOOTER //
// Diretorias.vue?5c9e2113